export default __webpack_public_path__ + "static/media/rubik-v12-latin-500.25fbce56.svg";